// Keep the category drawer accessible across navigation and editor reloads.
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.me-mobile-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
document.addEventListener('click',event=>{const menu=document.querySelector('.me-mobile-menu[open]');if(menu&&!menu.contains(event.target))menu.open=false;});

/* Fit the photographed object inside the product frame, accounting for white source margins. */
(() => {
  const selector = 'main[data-template="product"] .product-information media-gallery slideshow-slide .product-media__image';
  function prepare(img) {
    if (img.dataset.meObjectFit) return;
    img.dataset.meObjectFit = 'pending';
    const analyse = () => {
      if (!img.naturalWidth) return;
      try {
        const canvas = document.createElement('canvas');
        const ratio = Math.min(1, 360 / Math.max(img.naturalWidth, img.naturalHeight));
        const w = canvas.width = Math.round(img.naturalWidth * ratio);
        const h = canvas.height = Math.round(img.naturalHeight * ratio);
        const ctx = canvas.getContext('2d', {willReadFrequently: true});
        ctx.drawImage(img, 0, 0, w, h);
        const data = ctx.getImageData(0, 0, w, h).data;
        let left=w, top=h, right=0, bottom=0;
        for(let y=0;y<h;y++) for(let x=0;x<w;x++) {
          const i=(y*w+x)*4;
          if(data[i+3]>32 && Math.min(data[i],data[i+1],data[i+2])<235) {
            left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);
          }
        }
        if(right<=left || bottom<=top) return;
        const box = img.parentElement;
        const fit=()=>{
          const W=box.clientWidth,H=box.clientHeight;
          if(!W||!H)return;
          const base=Math.min(W/w,H/h);
          const scale=Math.min(4, .86*W/((right-left+1)*base), .86*H/((bottom-top+1)*base));
          const dx=(w/2-(left+right+1)/2)*base*scale;
          const dy=(h/2-(top+bottom+1)/2)*base*scale;
          img.style.padding='0';
          img.style.transformOrigin='center';
          img.style.transform=`translate(${dx}px, ${dy}px) scale(${scale})`;
          img.dataset.meObjectFit='ready';
        };
        new ResizeObserver(fit).observe(box);fit();
      } catch (_) { img.dataset.meObjectFit='fallback'; }
    };
    if(img.complete)analyse();else img.addEventListener('load',analyse,{once:true});
  }
  const init=()=>document.querySelectorAll(selector).forEach(prepare);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
